import axios from "axios";
import React, { useEffect, useState } from "react";
import { Check, X } from "react-feather";
import Modal from "react-modal";
import { useNavigate } from "react-router";
import { useAvaliacao } from "../../../Hooks/avaliado";
import { useCartorio } from "../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { useFuncionarioPrefeitura } from "../../../Hooks/funcionarioPrefeitura";
import { usePrefeitura } from "../../../Hooks/usePrefeitura";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/api";
import theme from "../../../Styles/theme";
import {
  app_base_url,
  baseUrlApiNotoficacoes,
  base_url_unico_api,
} from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { retiraVerificadores } from "../../../Utils/retiraVerificadores";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";
import { IAdquirinte } from "../Adquirinte";
import { ITransmitente } from "../Transmitente";
import {
  Button,
  Container,
  HelperButtons,
  Item,
  Lista,
  Span,
  Title,
} from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
  adquirinte: IAdquirinte;
  cod: string;
}

export function AvaliarImovel({
  open,
  onClose,
  imovel,

  adquirinte,
  cod,
}: Props) {
  const [aliquota, setAliquota] = useState(2);
  const [aliquota2, setAliquota2] = useState(2);
  const [totalDeclaradoMenosEntrada, setTotalDeclaradoMenosEntrada] = useState(0);
  const [entrada, setEntrada] = useState(0);
  const [restanteAvaliacao, setRestanteAvaliacao] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const { cartorioIsLogged, checarToken } = useCartorio();
  const { avaliado, createAvaliacao, updateAvaliacao } = useAvaliacao();
  const {
    prefeituraIsLogged,
    checarTokenPrefeitura,
    bancoPrefeitura,
    carregaLogo,
  } = usePrefeitura();
  const {
    funcionarioPrefeituraIsLogged,
    checarTokenFuncionarioPrefeitura,
    FuncionarioPrefeitura,
  } = useFuncionarioPrefeitura();
  const navigate = useNavigate();

  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  async function execute() {
    try {
      if (cartorioIsLogged) {
        await checarToken();
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }
      if (!imovel.VENC) {
        setError({
          message: "A data de vencimento da guia é inválida!",
          title: "Dados inválidos",
        });
        return;
      }
      if (imovel.VENC && new Date(imovel.VENC.toString()) < new Date()) {
        setError({
          message: "A data de vencimento da guia é inválida!",
          title: "Dados inválidos",
        });
        return;
      }

      setLoading(true);
      if (!imovel.NUMERO || imovel.NUMERO == 0) {
        try {
          const proximo_numero_consulta = await api.get(
            `/imovel/proximo_numero_proceso/${imovel.PREFEITURA_ID}/${new Date(
              imovel.DATA_CRIACAO
            ).getFullYear()}`
          );

          const prox_numero =
            Number(proximo_numero_consulta.data[0].MAXIMO_NUMERO) + 1;
          imovel.NUMERO = Number(prox_numero);

          const { data } = await api.patch(
            `/imovel${isRural() ? "-rural" : ""}/atera-numero-guia`,
            {
              id: imovel.ID,
              guia: imovel.NUMERO,
              entidade_id: imovel.PREFEITURA_ID,
            }
          );

          if (data.status == false) {
            window.alert(data.mensagem);
            return;
          }
        } catch (e) {
          window.alert("Não foi possível identificar o número da guia!");
          return;
        }
      }

      //window.alert("ACHO Q INFORMOU")
      const { data } = await api.patch(
        `/imovel${isRural() ? "-rural" : ""}/avaliar/${imovel.ID}/${FuncionarioPrefeitura.CPF
        }`
      );
      // await axios.post(
      //   `${baseUrlApiNotoficacoes}/cartorio/imovel-avaliado/cartorio/${imovel.CARTORIO_ID}`,
      //   {
      //     isRural: isRural() ? true : false,
      //     imovel_id: imovel.ID,
      //   }
      // );

      if (imovel.CARTORIO_ID == undefined) {
        await confirmarAvaliacao();
      }

      onClose();

      window.location.reload();
    } catch (error) {
      setError({
        message:
          "Não foi possível finalizar a avaliação do ímovel, tente novamente mais tarde!",
        title: "Ops",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregaLogo(imovel.PREFEITURA_ID);
  }, []);

  useEffect(() => {
    const terreonoValorTotal = imovel.VALOR_CARTORIO_TERRENO
      ? imovel.VALOR_CARTORIO_TERRENO
      : 0;
    const benfeitoriasValoTotal = imovel.VALOR_CARTORIO_BENFEITORIAS
      ? imovel.VALOR_CARTORIO_BENFEITORIAS
      : 0;
    setTotalDeclaradoMenosEntrada((terreonoValorTotal + benfeitoriasValoTotal) - (imovel.ENTRADA ? imovel.ENTRADA : 0));

    setEntrada(imovel.ENTRADA);

    setRestanteAvaliacao(((imovel.VALOR_PREFEITURA_TERRENO
      ? imovel.VALOR_PREFEITURA_TERRENO
      : 0) + (imovel.VALOR_PREFEITURA_BENFEITORIAS
        ? imovel.VALOR_PREFEITURA_BENFEITORIAS
        : 0)) - (terreonoValorTotal + benfeitoriasValoTotal))


    if (imovel.ALIQUOTA) {
      setAliquota(imovel.ALIQUOTA);
    }

    if (imovel.ALIQUOTA2) {
      setAliquota2(imovel.ALIQUOTA2);
    }
  }, [
    imovel.VALOR_PREFEITURA_TERRENO,
    imovel.VALOR_PREFEITURA_BENFEITORIAS,
    imovel.ALIQUOTA,
    imovel.ALIQUOTA2,
  ]);

  async function informar() {
    const helperVenc = new Date(imovel.VENC ? imovel.VENC : "");

    try {
      const avaliador = await api.get(
        `/avaliador/${imovel.ID}/${isRural() ? 1 : 0}`
      );


      const chave = `${isRural() ? "2" : "1"}${imovel.ID}`;
      //window.alert( chave)
      if (!imovel.TIPO_TRIBUTACAO) {
        const teste = await axios.post(`${base_url_unico_api}/informar`, {
          bancoNum: bancoPrefeitura.trim().substring(0, 1),
          bancoNome: bancoPrefeitura
            .replace("1-", "")
            .replace("2-", "")
            .trim(),

          INFORME_ITBI: {
            BASE: ((imovel.VALOR_PREFEITURA_BENFEITORIAS ? imovel.VALOR_PREFEITURA_BENFEITORIAS : 0) + (imovel.VALOR_PREFEITURA_TERRENO ? imovel.VALOR_PREFEITURA_TERRENO : 0)),
            ISSQN:
              ((totalDeclaradoMenosEntrada) * (aliquota / 100) +
                (restanteAvaliacao + entrada) * (aliquota2 / 100)),
            CPFINFORMANTE: avaliador.data[0].FUNCIONARIO,
            CHAVE: chave,
            fornecedor: adquirinte.COD_UNICO,
            vencimento: imovel.VENC
              ? `${helperVenc.getFullYear()}/${helperVenc.getMonth() +
              1}/${helperVenc.getDate()}`
              : "",
            CODBARRA: cod,
            PROCESSO: imovel.NUMERO,
          },
        });
      }
    } catch (error) {
      console.log("Não foi possível cadastrar a guia:", error);
      throw new Error("Não foi possível cadastrar a guia:");
    }
  }

  useEffect(() => {
    if (funcionarioCartorioIsLogged) {
      checarTokenFuncionario();
    }
    if (cartorioIsLogged) {
      checarToken();
    }
    if (prefeituraIsLogged) {
      checarTokenPrefeitura();
    }
    if (funcionarioPrefeituraIsLogged) {
      checarTokenFuncionarioPrefeitura();
    }
  }, [open]);

  async function confirmarAvaliacao() {
    setLoading(true);
    try {
      if (avaliado && avaliado.ID) {
        await updateAvaliacao(imovel.ID, 1);
      } else {
        await createAvaliacao(imovel.ID, 1);
      }
      if (imovel.nao_tributado) {
      } else {
        await informar();
      }

      onClose();
    } catch (error) {
      console.log(error);
      setError({
        message: "Não foi possível confirmar a avaliação!",
        title: "Ops",
      });
    } finally {
      setLoading(false);
      // window.location.reload();
    }
  }
  async function recusarAvaliacao() {
    setLoading(true);
    try {
      if (avaliado) {
        await updateAvaliacao(imovel.ID, 0);
      } else {
        await createAvaliacao(imovel.ID, 0);
      }
      // axios.post(
      //   `${baseUrlApiNotoficacoes}/prefeitura/notifica-novo-imovel/${imovel.PREFEITURA_ID}`,
      //   {
      //     isRural: isRural() ? true : false,
      //     imovel_id: imovel.ID,
      //   }
      // );
      // await api.delete(`/avaliador/${imovel.ID}/${isRural() ? 1 : 0}`);
      navigate(`${app_base_url}/imoveis${isRural() ? "-rurais" : ""}`);
    } catch (error) {
      console.log("ERRO: ", error);
      setError({
        message:
          "Não foi possível recusar e enviar o imovel para a reavaliação!",
        title: "Ops",
      });
    } finally {
      setLoading(false);
    }
  }

  function renderIcon(check: boolean) {
    if (check) {
      return <Check size={"max(1.2vw, 10px)"} color={theme.colors.success} />;
    } else {
      return <X size={"max(1.2vw, 10px)"} color={theme.colors.attention} />;
    }
  }

  function AvaliarComponent() {
    return (
      <>
     
        {!!adquirinte.COD_UNICO &&
          (imovel.VALOR_PREFEITURA_TERRENO
            ? imovel.VALOR_PREFEITURA_TERRENO
            : 0) +
          (imovel.VALOR_PREFEITURA_BENFEITORIAS
            ? imovel.VALOR_PREFEITURA_BENFEITORIAS
            : 0) >
          0 &&
          !!imovel.VENC ? (
          <>
            <Title>
              Tem certeza que deseja finalizar a avaliação do imóvel?
            </Title>
            <Span>
              Após o envio não será possível fazer nenhuma edição ou alteração
              de dados!
            </Span>

            <Button onClick={() => {
               
              execute()
            
            }}>FINALIZAR AVALIAÇÃO DO IMÓVEL</Button>
          </>
        ) : (
          <>
            <Title>
              Para finalizar a avaliação do imóvel, todos os requisitos abaixo
              devem ser preenchidos:
            </Title>
            <Lista>
              <Item>
                Código Único do Usuário {renderIcon(!!adquirinte.COD_UNICO)}
              </Item>
              <Item>
                Avaliação do Terreno / Benfeitorias
                {renderIcon(
                  (imovel.VALOR_PREFEITURA_TERRENO
                    ? imovel.VALOR_PREFEITURA_TERRENO
                    : 0) +
                  (imovel.VALOR_PREFEITURA_BENFEITORIAS
                    ? imovel.VALOR_PREFEITURA_BENFEITORIAS
                    : 0) >
                  0
                )}
              </Item>
              {/* <Item>
               Número da Guia {renderIcon(!!imovel.NUMERO)}
              </Item> */}
              <Item>
                Avaliação do Terreno{" "}
                {renderIcon(!!imovel.VALOR_PREFEITURA_TERRENO)}
              </Item>
              {/* <Item>
                Avaliação das Benfeitorias{" "}
                {renderIcon(
                  imovel.VALOR_PREFEITURA_BENFEITORIAS ? true : false
                )}
              </Item> */}
              <Item>Vencimento {renderIcon(!!imovel.VENC)}</Item>
            </Lista>
          </>
        )}
      </>
    );
  }

  function ConfirmarAvaliacaoComponent() {
    return (
      <>
        <Title>Tem certeza que deseja confirmar a avaliação?</Title>
        <Span>
          Caso deseje confirmar a avaliação clique em CONFIRMAR, caso tenha
          encontrado algum problema com a avaliação, clique em RECUSAR e seu
          imovel será reenviado para a avaliação!
        </Span>

        <HelperButtons>
          <Button onClick={recusarAvaliacao}>RECUSAR AVALIAÇÃO</Button>
          <Button onClick={confirmarAvaliacao}>CONFIRMAR AVALIAÇÃO</Button>
        </HelperButtons>
      </>
    );
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        {/* BARRAS:{cod} */}
        {imovel.AVALIADO ? ConfirmarAvaliacaoComponent() : AvaliarComponent()}
      </Container>

      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
